import React, {useCallback, useState} from 'react';
import {CookieAgreement} from "../index";
import styles from './CookieChecker.module.scss';
import {AppSettings} from "application/index";
import {getCookie, setCookie} from "infrastructure/common/cookies";
import clsx from "clsx";

export const CookieChecker = (props) => {
  const {className} = props;
  const [userCookiesAllowed, setUseCookie] = useState(getCookie(AppSettings.usePersonalInfoMessageCookieName) === 'true');
  const [isDisableMessage, disableUseCookieMessage] = useState(getCookie(AppSettings.disableUsePersonalInfoMessageCookieName) === 'true');

  const onAgreementCookie = useCallback(() => {
    setCookie(AppSettings.usePersonalInfoMessageCookieName, 'true', AppSettings.cookieExpirationDays);
    setUseCookie(true);
  }, [setUseCookie]);

  const disableCookieMessage = useCallback(() => {
    setCookie(AppSettings.disableUsePersonalInfoMessageCookieName, 'true', AppSettings.cookieExpirationDays);
    disableUseCookieMessage(true);
  }, [disableUseCookieMessage]);

  if(isDisableMessage) return <div/>;

  return !userCookiesAllowed && <>
    <CookieAgreement className={clsx(styles.container, className)} onAgreementCookie={onAgreementCookie} onClose={disableCookieMessage}/>
    {/*<div className={styles.overlay} />*/}
  </>;
};

CookieChecker.propTypes = {}

CookieChecker.defaultProps = {}

export default React.memo(CookieChecker);
